<div id="homebackground">
    <div id="homebox" class="home-box">
        <div class="home-margin-box">
            <div>
                <span>
                    <img src="assets/images/Acercade.png" />
                </span>
            </div>
            <br />
            <div>
                {{p1}}
            </div>
            <br />
            <div>
                {{p2}}
            </div>
            <br />
            <div>
                {{p3}}
            </div>
        </div>
    </div>
</div>
